import React from "react";
import { EXTENSION_GRANTS, removeTenure, renameTenure } from "./draftModel";
import { CheckField, NumberField, SelectField, Section } from "./fields";

const TenuresSettingsSection = ({ form, setForm, msgs, locked }) => {
  const setting = (field, value) =>
    setForm((prev) => ({ ...prev, settings: { ...prev.settings, [field]: value } }));

  return (
    <Section
      id="tenures"
      title="Tenures and settings"
      description="The monthly payment options and the rules around eligibility, upgrades and refunds. No tenure means the plan is sold one-time only."
      messages={msgs("tenures")}
    >
      <h6 className="warranty-subhead">Monthly tenures</h6>
      <div className="warranty-chips">
        {form.tenures.map((tenure, index) => (
          <div className="warranty-chip" key={index}>
            <NumberField
              id={`warranty-tenure-${index}`}
              label={`Tenure ${index + 1}`}
              kind="whole"
              unit="months"
              value={tenure}
              disabled={locked}
              messages={msgs(`tenures.${index}`)}
              onChange={(value) => setForm((prev) => renameTenure(prev, index, value))}
            />
            <button
              type="button"
              className="warranty-inline-btn is-danger"
              disabled={locked}
              aria-label={`Remove tenure ${tenure || index + 1}`}
              onClick={() => setForm((prev) => removeTenure(prev, index))}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        className="warranty-inline-btn is-primary mb-3"
        disabled={locked}
        onClick={() => setForm((prev) => ({ ...prev, tenures: [...prev.tenures, ""] }))}
      >
        Add tenure
      </button>

      <h6 className="warranty-subhead">Settings</h6>
      <div className="row">
        <div className="col-md-4">
          <NumberField
            id="warranty-eligibilityDays"
            label="Eligibility window"
            kind="whole"
            unit="days"
            value={form.settings.eligibilityDays}
            disabled={locked}
            help="How long after purchase a rider can buy the plan (0 to 90)."
            messages={msgs("settings.eligibilityDays")}
            onChange={(value) => setting("eligibilityDays", value)}
          />
        </div>
        <div className="col-md-4">
          <NumberField
            id="warranty-upgradeWindowDays"
            label="Upgrade window"
            kind="whole"
            unit="days"
            value={form.settings.upgradeWindowDays}
            disabled={locked}
            messages={msgs("settings.upgradeWindowDays")}
            onChange={(value) => setting("upgradeWindowDays", value)}
          />
        </div>
        <div className="col-md-4">
          <NumberField
            id="warranty-graceDays"
            label="Grace period"
            kind="whole"
            unit="days"
            value={form.settings.graceDays}
            disabled={locked}
            messages={msgs("settings.graceDays")}
            onChange={(value) => setting("graceDays", value)}
          />
        </div>
        <div className="col-md-4">
          <NumberField
            id="warranty-refundWindowDays"
            label="Refund window"
            kind="whole"
            unit="days"
            value={form.settings.refundWindowDays}
            disabled={locked}
            messages={msgs("settings.refundWindowDays")}
            onChange={(value) => setting("refundWindowDays", value)}
          />
        </div>
        <div className="col-md-4">
          <NumberField
            id="warranty-pendingExpiryHours"
            label="Unpaid purchase expires after"
            kind="whole"
            unit="hours"
            value={form.settings.pendingExpiryHours}
            disabled={locked}
            help="1 to 168 hours."
            messages={msgs("settings.pendingExpiryHours")}
            onChange={(value) => setting("pendingExpiryHours", value)}
          />
        </div>
        <div className="col-md-4">
          <SelectField
            id="warranty-extensionGrant"
            label="Extension cover"
            value={form.settings.extensionGrant}
            options={EXTENSION_GRANTS}
            disabled={locked}
            messages={msgs("settings.extensionGrant")}
            onChange={(value) => setting("extensionGrant", value)}
          />
        </div>
        <div className="col-md-12">
          <CheckField
            id="warranty-refundRequiresNoUse"
            label="A refund needs the plan to be unused"
            checked={form.settings.refundRequiresNoUse}
            disabled={locked}
            onChange={(value) => setting("refundRequiresNoUse", value)}
          />
        </div>
        <div className="col-md-12">
          <CheckField
            id="warranty-active"
            label="Active: offered to riders. Untick to take this plan off sale; buyers and upgrades already made stay as they are."
            checked={form.settings.active}
            disabled={locked}
            onChange={(value) => setting("active", value)}
          />
        </div>
      </div>
    </Section>
  );
};

export default TenuresSettingsSection;
